"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsoleAdapter = void 0;
const base_adapter_1 = require("./base.adapter");
class ConsoleAdapter extends base_adapter_1.BaseAdapter {
    logEvent(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { type, payload } = params;
            console.log(ConsoleAdapter.name, type, payload);
        });
    }
    setUserId(id) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log(ConsoleAdapter.name, 'SET_USER_ID', id);
        });
    }
    setUserProperties(user) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log(ConsoleAdapter.name, 'SET_USER_PROPERTIES', user);
        });
    }
    setBasicInfo(info) {
        console.log('Basic Info Params', info);
    }
}
exports.ConsoleAdapter = ConsoleAdapter;
//# sourceMappingURL=console.adapter.js.map